import axios from 'axios'

const actions = {
    async updateUsersCountry({ dispatch }, locationObj) {
        let response = await axios.put('/location/country', locationObj)
        if(response.data !== null){
            return dispatch('updateUserVal', response.data.result)
        }
    },
    
    async updateUsersCity({ dispatch }, locationObj) {
        let response = await axios.put('/location/city', locationObj)
        if(response.data !== null){
            return dispatch('updateUserVal', response.data.result)
        }
    },
    
    async updateIntlShopping({ dispatch }, locationObj) {
        let response = await axios.put('/location/internationalShop', locationObj)
        if(response.data !== null){
            return dispatch('updateUserVal', response.data.result)
        }
    },
}

export default {
    actions
}